import { render } from "./AboutComp.vue?vue&type=template&id=1430245a"
import script from "./AboutComp.vue?vue&type=script&lang=js"
export * from "./AboutComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__